<template>
  <div class="headerSearchBox">
    <div class="searchLeft">
      <van-icon class="searchIcon" name="search" />
      <Input :readonly="false" class="searchInput" placeholder="请输入产品名称/企业名称" maxlength="50" v-model="val" />
    </div>
    <van-button size="small" color="#FF6538" @click="queryHandler" type="primary">查询</van-button>
  </div>
</template>

<script>
import Input from '@/components/Input.vue';

export default {
  name: 'headerSearch',
  components: {
    Input,
  },
  data() {
    return {
      val: '',
      reg: [
        {
          pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/gi,
        },
      ],
    };
  },
  methods: {
    queryHandler() {
      this.$emit('getSearchValue', this.val);
    },
  },
  // watch: {
  //   val: {
  //     handler(e) {
  //       if (e === '') {
  //         this.$emit('getSearchValue', this.val);
  //       }
  //     },
  //   },
  // },
};
</script>
<style scoped>
.headerSearchBox{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  height: 50px;
  padding: 0 15px;
}
.searchLeft{
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  background: rgba(194,200,204,0.24);
  border-radius: 4px;
  flex: 1;
  height: 32px;
  padding: 0 12px;
  margin-right: 8px;
}
.searchInput{
  width: 100%;
  background: center;
}
.searchInput >>> input {
  width: 100%;
  background: center;
  padding: 12px 6px;
}
.headerSearchBox >>> .Input {
  padding: 0px;
}
.headerSearchBox >>> input::-webkit-input-placeholder {
  color: #B8C4CC;
}
.headerSearchBox >>>input::-moz-input-placeholder {
  color: #B8C4CC;
}
.headerSearchBox >>>input::-ms-input-placeholder {
  color: #B8C4CC;
}
</style>
